import { gql } from "@apollo/client";

export const ALL_SERVICE_STATUS=gql`query getAllServiceStatus($serviceNames: [String!]!) {
    getAllServiceStatus(serviceNames:$serviceNames) {
        items{
        serviceName
        isActive
        }
    }
}
`;

